import { ListenEvents as DefaultListenEvent } from './socketEventNames';

export type SocketService<ListenEvents extends string = DefaultListenEvent> = {
  socket: WebSocket;
  consumers: Partial<Record<ListenEvents, Array<(...args: any) => void>>>;
  shouldReconnect: boolean;
  isClosed: boolean;
  connect: () => void;
  disconnect: () => void;
  addListener: (event: ListenEvents, callback: (data: any) => void) => void;
  removeListener: (event: ListenEvents, callback: (data: any) => void) => void;
};

export default function <ListenEvents extends string>(connect: () => void) {
  return {
    socket: null,
    consumers: {},
    shouldReconnect: true,
    isClosed: true,
    connect,
    disconnect() {
      if (!this.socket) return;
      this.isClosed = true;
      this.socket.close();
    },
    addListener(event: ListenEvents, callback: (data: any) => void) {
      if (!this.consumers[event]) {
        this.consumers[event] = [callback];
      } else this.consumers[event].push(callback);
    },
    removeListener(event: ListenEvents, callback: (...args: any) => void) {
      const callbackArray = this.consumers[event];
      if (!callbackArray) return;
      this.consumers[event] = callbackArray.filter(
        (cb: any) => cb !== callback,
      );
    },
  } as SocketService<ListenEvents>;
}
